"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenPairsArray = flattenPairsArray;
exports.flattenedPairsToQueryString = void 0;
exports.objectToPairsArray = objectToPairsArray;
exports.pairsArrayToObject = pairsArrayToObject;
exports.parseQueryParam = parseQueryParam;
exports.queryStringToFlattenedPairsArray = void 0;
exports.queryStringToPairsArray = queryStringToPairsArray;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url-search-params"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/entries"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _endsWith2 = _interopRequireDefault(require("lodash/endsWith"));
var _pairs = require("../../pairs");
/**
 * Converts a flattened array of name/value pairs into a query string
 * @param  {Object} pairs Flatted pairs array
 * @return {String}       Query string
 */
const flattenedPairsToQueryString = pairs => (0, _map.default)(pairs).call(pairs, pair => pair.name + '=' + pair.value).join('&');

/**
 * Returns an array of name/value pairs (it is possible for duplicate names) contained in URLSearchParams object
 * @param  {Object} queryString The query string
 * @return {Object}             Flattened array of name/value pairs
 */
exports.flattenedPairsToQueryString = flattenedPairsToQueryString;
const queryStringToFlattenedPairsArray = queryString => {
  const searchParams = new _urlSearchParams.default((0, _last2.default)(queryString.split('?')));
  let pairs = [];

  /*
  * qs._list comes from the polyfill for the URLSearchParams class and must
  * be used because IE doesn't support symbols
  */
  if ((0, _isArray.default)(searchParams._list)) {
    var _context;
    pairs = (0, _map.default)(_context = searchParams._list).call(_context, pair => {
      return {
        name: pair.name,
        value: pair.value
      };
    });
  } else {
    for (const [name, value] of (0, _entries.default)(searchParams).call(searchParams)) {
      pairs.push({
        name,
        value
      });
    }
  }
  return pairs;
};

/**
 * Converts an array of name/value pairs to an object. If conflicting pairs are
 * encountered the last pair wins.
 * @param  {Object} pairs Array of name/value pairs
 * @return {Object}       Object representation of pairs
 */
exports.queryStringToFlattenedPairsArray = queryStringToFlattenedPairsArray;
function pairsArrayToObject(pairs) {
  return (0, _reduce.default)(pairs).call(pairs, (memo, pair) => {
    memo[pair.name] = (0, _pairs.isPairsArray)(pair.value) ? pairsArrayToObject(pair.value) : pair.value;
    return memo;
  }, {});
}

/**
 * Returns an array of name/value pairs from an object whose keys are parameter keys and whose values are parameter values
 * @param  {Object} params       Object to convert into name/value pairs
 * @return {Object}              Array of name/value pairs
 */
function objectToPairsArray(params) {
  var _context2;
  return (0, _reduce.default)(_context2 = (0, _keys.default)(params)).call(_context2, (memo, key) => {
    const value = params[key];
    const pair = {
      name: key,
      value: value && typeof value === 'object' && !(0, _isArray.default)(value) ? objectToPairsArray(value) : value
    };
    memo.push(pair);
    return memo;
  }, []);
}

/**
 * Converts a query string to an array of name/value pairs. Defaults to the current browser's query string.
 * This function is useful for cases that require that query parameters remain in order.
 *
 * @param  {String} queryString Query string to convert
 * @return {Object}
 */
function queryStringToPairsArray(queryString) {
  const pairs = queryStringToFlattenedPairsArray(queryString);
  let params = [];
  params = (0, _reduce.default)(pairs).call(pairs, (memo, pair) => {
    const parsed = parseQueryParam(pair.name, pair.value, (name, value) => {
      return (0, _pairs.isPair)(value) ? {
        name,
        value: [value]
      } : {
        name,
        value
      };
    });
    memo = (0, _pairs.mergePairs)(memo, [parsed], true);
    return memo;
  }, params);
  return params;
}

/**
 * Parses a single query parameter into the appropriate type.
 * If the name contains empty braces then the value parsed into an array.
 * If the name contains non-empty braces then value is parse into another object.
 * @param  {String}   name  Name of the query parameter
 * @param  {String}   value Value of the query parameter
 * @param  {Function} cb    An optional callback used to determine the shape of parsed data
 * @return {Object}         Object representation of query parameter
 */
function parseQueryParam(name, value, cb) {
  const openBracketIndex = (0, _indexOf.default)(name).call(name, '[');
  let closeBracketIndex = -1;
  let currentKey = name;
  let remainingKeys = '';
  if (openBracketIndex > -1) {
    currentKey = name.substring(0, openBracketIndex);
    remainingKeys = name.substr(openBracketIndex + 1);
    closeBracketIndex = (0, _indexOf.default)(remainingKeys).call(remainingKeys, ']');
    remainingKeys = remainingKeys.substring(0, closeBracketIndex) + remainingKeys.substring(closeBracketIndex + 1);
  }
  if (remainingKeys) {
    value = parseQueryParam(remainingKeys, value, cb);
  } else if (!remainingKeys && (0, _endsWith2.default)(name, '[]')) {
    value = [value];
  }
  if (cb) {
    return cb(currentKey, value);
  }
  return {
    [currentKey]: value
  };
}

/**
 * Creates a single level name/value pair array with complex pair names represeting
 * nested parameters.
 * @param  {Object}   pairs    Array of nested name/value pairs
 * @param  {String}   prefix   Prefix to add to the name property
 * @param  {Function} encoder  Ecoder for the value
 * @return {Object}        Array of flattened query parameter pairs
 */
function flattenPairsArray(pairs, prefix = '', encoder = encodeURIComponent) {
  encoder = encoder || (string => string);
  return (0, _reduce.default)(pairs).call(pairs, (memo, pair) => {
    const {
      value
    } = pair;
    const prefixedParentKey = prefix ? prefix + '[' + encoder(pair.name) + ']' : encoder(pair.name);
    if (!value || typeof value !== 'object') {
      memo.push({
        name: prefixedParentKey,
        value: encoder(value)
      });
    } else if ((0, _pairs.isPairsArray)(value)) {
      memo = (0, _concat.default)(memo).call(memo, flattenPairsArray(value, prefixedParentKey, encoder));
    } else {
      memo = (0, _concat.default)(memo).call(memo, (0, _map.default)(value).call(value, item => ({
        name: prefixedParentKey + '[]',
        value: encoder(item)
      })));
    }
    return memo;
  }, []);
}